import { app } from '@/translations/pl/app'
import { blockly } from '@/translations/pl/blockly'
import { busLogs } from '@/translations/pl/busLogs'
import { camera } from '@/translations/pl/camera'
import { columns } from '@/translations/pl/columns'
import { common } from '@/translations/pl/common'
import { roles } from '@/translations/pl/common/roles'
import { configuration } from '@/translations/pl/configuration'
import { dashboard } from '@/translations/pl/dashboard'
import { editor } from '@/translations/pl/editor'
import { files } from '@/translations/pl/files'
import { finishedConfigurations } from '@/translations/pl/finishedConfigurations'
import { flow } from '@/translations/pl/flow'
import { groups } from '@/translations/pl/groups'
import { login } from '@/translations/pl/login'
import { packages } from '@/translations/pl/packages'
import { pathway } from '@/translations/pl/pathway'
import { profile } from '@/translations/pl/profile'
import { users } from '@/translations/pl/users'

export const pl = {
  app,
  login,
  common,
  users,
  flow,
  dashboard,
  columns,
  configuration,
  editor,
  groups,
  packages,
  files,
  profile,
  roles,
  blockly,
  busLogs,
  pathway,
  camera,
  finishedConfigurations,
}
